<!--&================= TITLE =================&-->
<div class="title-components">
  <h1>Contribuciones totales CDMS</h1>
</div>

<!--&================= CONTAINER BAR NAVIGATION =================&-->

<div class="Options-Menu">
  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fas fa-hashtag"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="information">
        <div class="option">
          <div class="Option-Title"><h2>Total de HOE</h2></div>
          <div class="Input-Option">{{ DataChartAreaCCP.Total }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fas fa-hashtag"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="information">
        <div class="option">
          <div class="Option-Title"><h2>Total general CDMS</h2></div>
          <div class="Input-Option">{{ allContributions() }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-charts">
  <div class="container-left">
    <div class="container-global-components chart-ccp">
      <app-simple-chart-arear [DataChartArea]="DataChartAreaCCP" />
    </div>
  </div>
  <div class="container-right">
    <div class="container-global-components chart-bar-cdms">
      <app-simple-chart-barrc [DataChartBar]="DataChartBar" />
    </div>
  </div>
</div>
